import { FormControl, FormErrorMessage, FormLabel, Select } from '@chakra-ui/react';

interface Dosage {
  id: string;
  label: string;
  defaultQuantity: number;
  priceMultiplier: number;
}

interface DosageSelectProps {
  drugId?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  dosages: Dosage[];
  isLoading?: boolean;
}

export default function DosageSelect({ drugId, value, onChange, error, dosages, isLoading }: DosageSelectProps) {
  return (
    <FormControl isInvalid={!!error}>
      <FormLabel>Dosage</FormLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Select dosage"
        isDisabled={isLoading || dosages.length === 0}
      >
        {dosages.map((dosage) => (
          <option key={dosage.id} value={dosage.id}>
            {dosage.label}
          </option>
        ))}
      </Select>
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
}
